/*
 * @FileName       : action.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action constants to store all the constants belongs to actions.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

export const UI = {
  NAVIGATE : 'UI_NAVIGATE',
  NAVIGATE_RESPONSE : 'UI_NAVIGATE_RESPONSE',
  SHOW_LOADER : 'SHOW_LOADER',
  SET_API_ERROR: 'SET_API_ERROR',
  SET_NAV_DRAWER: 'SET_NAV_DRAWER',
  SET_URL_FILTER: 'SET_URL_FILTER',
  SET_NAV_STATE: 'SET_NAV_STATE',
  AUTH_PROCESSING: 'AUTH_PROCESSING',
  SET_GLOBAL_ROWS_PER_PAGE: 'SET_GLOBAL_ROWS_PER_PAGE',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  PRELOAD_DATA: 'PRELOAD_DATA',
  SET_CUSTOMERS: 'SET_PRELOADED_CUSTOMERS',
  SET_BACKEND_POLLER: 'SET_BACKEND_POLLER',
  SET_PRELOADED_SERVICE_TYPES: 'SET_PRELOADED_SERVICE_TYPES',
  SET_PRELOADED_ADDRESS_TYPES: 'SET_PRELOADED_ADDRESS_TYPES'
};

export const GROUP = {
  GET_LIST: 'GET_GROUP_LIST',
  SET_LIST: 'SET_GROUP_LIST',
  GET_GROUP_DETAILS: 'GET_GROUP_DETAILS',
  SET_GROUP_DETAILS: 'SET_GROUP_DETAILS',
  GET_RX_LIST: 'GET_GROUP_RX_LIST',
  SET_RX_LIST: 'SET_GROUP_RX_LIST',
  UPDATE_GROUP_SERVICE_TYPE: 'UPDATE_GROUP_SERVICE_TYPE'
}

export const WORKGROUP = {
  GET_LIST: 'GET_WORKGROUP_LIST',
  SET_LIST: 'SET_WORKGROUP_LIST',
  CREATE: 'CREATE_WORKGROUP',
  UPDATE: 'UPDATE_WORKGROUP',
  REPROCESS: 'REPROCESS_WORKGROUP'
}

export const RX = {
  GET_ALERT_TRANSACTIONS: 'GET_ALERT_TRANSACTIONS',
  SET_ALERT_TRANSACTIONS: 'SET_ALERT_TRANSACTIONS',
  GET_RX_EXCEPTION_COUNT: 'GET_RX_EXCEPTION_COUNT',
  SET_RX_EXCEPTION_COUNT: 'SET_RX_EXCEPTION_COUNT',
  GET_RX_LIST: 'GET_RX_LIST',
  SET_RX_LIST: 'SET_RX_LIST',
  UPDATE: 'UPDATE',
  RESOLVE: 'RESOLVE',
  CANCEL: 'CANCEL',
  IMPORT_REPROCESS: 'IMPORT_REPROCESS',
}

export const USER_MANAGEMENT = {
  LIST_REQUEST: 'GET_USER_LIST_REQUEST',
  LIST_RESPONSE: 'GET_USER_LIST_RESPONSE',
  INVITE_USER: 'INVITE_USER',
  DELETE_USER: 'DELETE_USER',
  UPDATE_USER: 'UPDATE_USER',
  LOGIN: 'LOGIN',
  SET_AUTH_USER: 'SET_AUTH_USER',
  REFRESH_SESSION: 'REFRESH_SESSION',
  REFRESH_SESSION_IN_BACKGROUND: 'REFRESH_SESSION_IN_BACKGROUND',
  LOGOUT: 'LOGOUT',
  PING_USER_SERVICE: 'PING_USER_SERVICE'
}

export const PRODUCTS = {
  SET_PRELOADED_PRODUCTS: 'SET_PRELOADED_PRODUCTS',
  LIST_REQUEST: 'GET_PRODUCT_LIST',
  LIST_RESPONSE: 'SET_PRODUCT_LIST',
  CREATE_PRODUCT: 'SAVE_NEW_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  GET_PACKING_ITEMS: 'GET_PACKING_ITEMS',
  SET_PACKING_ITEMS: 'SET_PACKING_ITEMS',
  CREATE_PACKING_ITEM: 'CREATE_PACKING_ITEM',
  UPDATE_PACKING_ITEM: 'UPDATE_PACKING_ITEM',
  DELETE_PACKING_ITEM: 'DELETE_PACKING_ITEM',
  GET_PACK_SETS: 'GET_PACK_SETS',
  SET_PACK_SETS: 'SET_PACK_SETS',
  CREATE_PACK_SET: 'CREATE_PACK_SET',
  UPDATE_PACK_SET: 'UPDATE_PACK_SET',
  DELETE_PACK_SET: 'DELETE_PACK_SET',
}

export const REPORT = {
  GET_INVENTORY_REPORT: 'GET_INVENTORY_REPORT',
  SET_INVENTORY_REPORT: 'SET_INVENTORY_REPORT',
}
